import classNames from "classnames";
import React from "react";
import components from "../styles/components.module.css";

export default function Heading(props) {
  const { className, children, ...componentProps } = props;

  return (
    <h1
      className={classNames(components.heading, className)}
      {...componentProps}
    >
      {children}
    </h1>
  );
}
